import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledSocialMenu = styled('div')(
  ({ theme }) => `
    margin-bottom: ${theme.DS_spacing(['md'])};
  `,
);

export const StyledSocialMenuHeader = styled(Typography)(
  ({ theme }) => `
    margin-bottom: ${theme.DS_spacing(['md'])};
    display: block;
      ${theme.breakpoints.down('lg')} {
      display: none;
    }
  `,
);

export const StyledSocialMenuList = styled('ul')(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.DS_spacing(['xxs'])};
    margin-bottom: ${theme.DS_spacing(['md'])};
  `,
);

export const StyledSocialMenuListItem = styled('li')(
  ({ theme }) => `
    a {
      border-radius: 40px;
      background: ${theme.DS_palette.background.light};
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
    }
  `,
);

export const StyledInfluencerLink = styled(Typography)(
  ({ theme }) => `
    color: ${theme.DS_palette.primary.black};
    text-transform: uppercase;
  `,
);
